import { TEST_IDS } from '@va/constants';
import { NavAddCircle } from '@va/icons';
import { Button } from '@va/ui/design-system';

type DashedButtonDividerProps = {
  onClick: () => void;
};

export function DashedButtonDivider({ onClick }: DashedButtonDividerProps) {
  return (
    <div className='flex items-center w-full relative'>
      <div className='flex-1 relative h-1.5px bg-[linear-gradient(to_right,#C3C3C3_0%,#C3C3C3_50%,transparent_50%)] bg-size-[6px_1.5px] bg-repeat-x'>
        <div className='absolute inset-0 bg-linear-to-l from-transparent to-white' />
      </div>

      <Button
        data-testid={TEST_IDS.generic.funnels.editor.addLevelBtn}
        icon={(_, color) => <NavAddCircle className='shrink-0' color={color} />}
        className='w-13.5 h-9! bg-purple-bright'
        onClick={onClick}
      />

      <div className='flex-1 relative h-1.5px bg-[linear-gradient(to_right,transparent_50%,#C3C3C3_50%,#C3C3C3_100%)] bg-size-[6px_1.5px] bg-repeat-x'>
        <div className='absolute inset-0 bg-linear-to-r from-transparent to-white' />
      </div>
    </div>
  );
}
